import React from 'react';
import ExcelJS from 'exceljs';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { Button } from 'react-bootstrap';

const ExportCommitPrToExcelButton = ({ titleData, headers, data, processRowDataArray, filename, sheetName }) => {
    const handleExport = async () => {
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();

        // Add a worksheet
        const worksheet = workbook.addWorksheet(sheetName || 'Sheet1');

        worksheet.addRow([titleData]);
        worksheet.mergeCells(`A1:${String.fromCharCode(64 + headers.length)}1`); // Dynamically merge based on the number of headers

        const headerCell = worksheet.getCell('A1');
        // Style the header
        headerCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF' }, // Black
        };
        headerCell.font = {
            bold: true,
            size: 16,
        };

        // Add column headers
        worksheet.addRow(headers);

        // Style cells A2 to K2 and set column widths
        headers.forEach((header, index) => {
            const colLetter = String.fromCharCode(65 + index); // Get the column letter (A, B, C, etc.)
            const cell = worksheet.getCell(colLetter + '2'); // Target the header cells (A2, B2, C2, etc.)
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF000000' } // Black background
            };

            // Set column width
            worksheet.getColumn(index + 1).width = 30; // Adjust width as needed
            worksheet.getColumn(index + 1).alignment = { vertical: "middle", horizontal: "left" }; // Adjust width as needed
        });

        headerCell.alignment = { vertical: 'middle', horizontal: 'center' };
        // Add data rows
        data.forEach(item => {
            const row = processRowDataArray(item);
            worksheet.addRow(row);
        });

        // Generate the Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Save the file
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${filename}.xlsx`);
    };

    return (
        <Button color='info' onClick={handleExport}>
            <i className="fa fa-file-excel" aria-hidden="true" />&nbsp;Export to Excel
        </Button>
    );
};

ExportCommitPrToExcelButton.propTypes = {
    titleData: PropTypes.string.isRequired,
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    processRowDataArray: PropTypes.func.isRequired,
    filename: PropTypes.string.isRequired,
    sheetName: PropTypes.string.isRequired
}

export default ExportCommitPrToExcelButton;
